<template>
  <div>
    <iframe
      src="http://3971bd3f.r11.cpolar.top/ui/chat/2f2ee07bd8bb678e"
      style="width: 1400px; height: 710px;margin: 0 auto"
      frameborder="0"
      allow="microphone">
    </iframe>
  </div>
</template>


<script>
  export default{
    name: "Assistant",
  }
</script>


<style>

</style>
